export default {
  NAME: 'Name',
  SURNAME: 'Surname',
  EMAIL: 'Email',
  MESSAGE: 'Message',
  PRIVACY: 'Accept <a href="https://www.iubenda.com/privacy-policy/96914721" target="_blank" rel="noopener"><bdi>Privacy</bdi></a>',
  SUBMIT: 'Send',
  SENDING: 'Sending',
  SENT: 'Sent',

  TXTLINE1: 'Thanks',
  TXTLINE2: 'we’ll get in touch',
  TXTLINE3: 'as soon as possible.',

  ABOUT: 'We are',
  INVESTIMENTI: 'Investments',
  TEAM: 'Team',
  CONTATTI: 'Contacts',

  FORM_THX: 'Message sent, thank for getting in touch.',

  LABEL1: 'Year of investment',
  LABEL2: 'Quota',
  LABEL3: 'Other investors',

  COOKIE_TEXT: 'By using this website, you agree to our use of <a href="https://www.iubenda.com/privacy-policy/96914721/cookie-policy" target="_blank" rel="noopener"><bdi>cookie</bdi></a>. We use cookies to provide you with a great experience. ',
  COOKIE_BTN: 'Accept',

  ERROR_TITLE: 'Please Help Me!',
  VIDEO_VOLUME: 'Click to Listen',
  VIDEO_MUTE: 'Click to Mute',
  GO_BACK: 'Go to Index',

  MENU_POLICY: '<a href="https://www.iubenda.com/privacy-policy/96914721" target="_blank" rel="noopener" aria-label="Privacy"><bdi>Privacy</bdi></a>',
  MENU_COOKIE: '<a href="https://www.iubenda.com/privacy-policy/96914721/cookie-policy" target="_blank" rel="noopener" aria-label"Cookie"><bdi>Cookie</bdi></a>',
};
